import { UserRole } from "src/types"

export function isUserWorker({ role }: { role: UserRole }) {
  return (role & UserRole.User) > 0
}
export function isUserManager({ role }: { role: UserRole }) {
  return (role & UserRole.Manager) > 0
}
export function isUserAdmin({ role }: { role: UserRole }) {
  return (role & UserRole.Admin) > 0
}
export function isUserSuperAdmin({ role }: { role: UserRole }) {
  return (role & UserRole.SuperAdmin) > 0
}
// Managers and admins (incl. super admins) may perform task actions.
// Plain workers (regular members) are blocked.
export function canManageTasks({ role }: { role: UserRole }) {
  return (
    isUserManager({ role }) ||
    isUserAdmin({ role }) ||
    isUserSuperAdmin({ role })
  )
}
export function hasUserAccess({
  neededRole,
  userRole,
}: {
  neededRole: UserRole
  userRole: UserRole
}) {
  if (neededRole & userRole) {
    // has direct role
    return true
  }
  // has propagated role (higher in hierarchy):
  switch (true) {
    case isUserSuperAdmin({ role: neededRole }): {
      return isUserSuperAdmin({ role: userRole })
    }
    case isUserAdmin({ role: neededRole }): {
      return (
        isUserAdmin({ role: userRole }) || isUserSuperAdmin({ role: userRole })
      )
    }
    case isUserManager({ role: neededRole }): {
      return (
        isUserManager({ role: userRole }) ||
        isUserAdmin({ role: userRole }) ||
        isUserSuperAdmin({ role: userRole })
      )
    }
    case isUserWorker({ role: neededRole }): {
      return (
        isUserWorker({ role: userRole }) ||
        isUserManager({ role: userRole }) ||
        isUserAdmin({ role: userRole }) ||
        isUserSuperAdmin({ role: userRole })
      )
    }
    // otherwise has no access
    default: {
      return false
    }
  }
}
